export class AppConfig {
    public readonly api: string = 'https://v3.netpap.co.ke/api';
    public readonly url: string = 'https://v3.netpap.co.ke';
    public readonly tr069Url: string = 'https://acs.netpap.co.ke';  // ✅ New key for WebSocket
    public readonly tr069UrlApi: string = 'https://acs.netpap.co.ke/api';  // ✅ New key for WebSocket
    public readonly tr069UrlApi2: string = 'https://acs.netpap.co.ke/api2';  // ✅ New key for WebSocket
    public readonly COMPANY_NAME:string = 'RUI INTERNET';
    public readonly websocketUrl: string = 'wss://acs.netpap.co.ke/tr069/ws';  // ✅ New key for WebSocket


    public readonly pageSize: number = 10;
    public readonly pageSizeOptions: Array<number> = [0, 10, 20, 50, 100, 500];
    public readonly securityToken: string = '1234567';

}
